import { useTranslation } from 'react-i18next'
import { RouteChildrenProps } from 'react-router-dom'

import { WishesForm2 } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import useSaveOnBack from 'hooks/useSaveOnBack'

import usePage from '../../hooks/usePage'

const Wishes2Page: React.FC<RouteChildrenProps> = () => {
  const { initialValues = {}, onBack, ...page } = usePage()
  const { t } = useTranslation()
  const formikRef = useSaveOnBack({ onBack })

  return (
    <PageLayout title={t('category.additional_details')} subtitle={t('subcategory.let_us_know_about_you')}>
      <WishesForm2 innerRef={formikRef} initialValues={initialValues} loading={false} {...page} />
    </PageLayout>
  )
}

export default Wishes2Page
